import React, { useState, useRef } from 'react';

const CrossHair = ({position_x, position_y,setposition_x,setposition_y }) => {
  const [mouseIsDown, setMouseIsDown] = useState(false);
  
  const handleMouseDown = (e) => {
    setMouseIsDown(true);
    changeCoordinate(e)
  };

  const handleMouseUp = (e) => {
    setMouseIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (mouseIsDown) {
      changeCoordinate(e)
    }
  };
  
  const crossHairRef = useRef(null);  // 指向crossHair对象自身的ref
  const changeCoordinate = (e) => {
    const boundingBoxOfCrossHair = crossHairRef.current.getBoundingClientRect();
    const offsetX = e.pageX - boundingBoxOfCrossHair.left;  // 鼠标选中位置与viewer左侧的相对距离
    const offsetY = e.pageY - boundingBoxOfCrossHair.top;  // 鼠标选中位置与viewer上侧的相对距离
    setposition_x(offsetX / boundingBoxOfCrossHair.width)
    setposition_y(offsetY / boundingBoxOfCrossHair.height)

    // setlayer({
    //   canvas: Canvas,
    //   x: offsetX / boundingBoxOfCrossHair.width,
    //   y: offsetY / boundingBoxOfCrossHair.height,
    // })
  };
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex:999
      }}
      onMouseMove={handleMouseMove}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      ref={crossHairRef}

    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: `${position_x * 100}%`,
          width: '1px',
          height: '100%',
          backgroundColor: '#72ece9',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: `${position_y * 100}%`,
          left: 0,
          width: '100%',
          height: '1px',
          backgroundColor: '#72ece9',
        }}
      />
    </div>
  );
};

export default CrossHair;
